<template>
  <SportDiscoverTeamsOrganize sport="rugby" />
</template>

<script>
import SportDiscoverTeamsOrganize from "@/routes/match_hub/shared/SportDiscoverTeamsOrganize.vue";

export default {
  name: "RugbyOrganizeMatch",
  components: { SportDiscoverTeamsOrganize },
};
</script>
